// src/App.tsx

import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/globals.css';
import { AuthProvider } from './context/AuthContext'; 

// Components
import PageLayout from './components/PageLayout/PageLayout';
import FixedScale from './components/FixedScale/FixedScale';
import CartPopup from './components/Popups/CartPopup/CartPopup';
import AccountPopup from './components/Popups/AccountPopup/AccountPopup';

// Pages - Principais
import HomePage from './pages/HomePage/HomePage';
import PluginsPage from './pages/PluginsPage/PluginsPage';
import ShopPage from './pages/ShopPage/ShopPage';
import KitsPage from './pages/KitsPage/KitsPage';
import AboutPage from './pages/AboutPage/AboutPage';

// Pages - Autenticação
import RegisterPage from './pages/RegisterPage/RegisterPage';
import GoogleCallbackPage from './pages/RegisterPage/GoogleCallbackPage';
import ResetPasswordPage from './pages/ResetPasswordPage/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage/VerifyEmailPage';

// Import da Nova Página de Sucesso
import PaymentSuccessPage from './pages/PaymentSuccessPage/PaymentSuccessPage';

function App() {
  const [isCartOpen, setCartOpen] = useState(false);
  const [isAccountOpen, setAccountOpen] = useState(false);
  const [initialRegister, setInitialRegister] = useState(false);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const action = params.get('action');
    if (action === 'register') {
      setAccountOpen(true);
      setInitialRegister(true);
      // Limpa a URL sem recarregar a página
      const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      window.history.replaceState({path: newUrl}, '', newUrl);
    } else if (action === 'login') {
      setAccountOpen(true);
      setInitialRegister(false);
      const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      window.history.replaceState({path: newUrl}, '', newUrl);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <FixedScale>
        <div className="App" style={{ height: '100%' }}>
          <Routes>
            {/* --- Rotas com o Layout Principal (Navbar, Footer) --- */}
            <Route element={<PageLayout 
                              onCartClick={() => setCartOpen(true)} 
                              onAccountClick={() => setAccountOpen(true)}
                            />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/plugins" element={<PluginsPage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/kits" element={<KitsPage />} />
              <Route path="/about" element={<AboutPage />} />
            </Route>

            {/* --- Rotas de Autenticação (Tela Cheia / Sem Layout Padrão) --- */}
            
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/google-callback" element={<GoogleCallbackPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />

            {/* --- AQUI ESTÁ A NOVA ROTA --- */}
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            {/* ----------------------------- */}

            {/* Rota Coringa (404) - Redireciona qualquer link desconhecido para Home */}
            <Route path="*" element={<Navigate to="/" replace />} />
            
          </Routes>

          {/* --- Popups Globais --- */}
          {isCartOpen && <CartPopup onClose={() => setCartOpen(false)} />}
          {isAccountOpen && <AccountPopup onClose={() => setAccountOpen(false)} initialRegister={initialRegister} />}
        </div>
        </FixedScale>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;